var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrouptransportation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4208 22.3684H7.8945C4.98661 22.3684 2.63135 20.0132 2.63135 17.1053V5.26316C2.63135 2.35526 4.98661 0 7.8945 0H18.4208C21.3287 0 23.684 2.35526 23.684 5.26316V17.1053C23.684 20.0132 21.3287 22.3684 18.4208 22.3684ZM7.8945 2.63158C6.44714 2.63158 5.26293 3.81579 5.26293 5.26316V17.1053C5.26293 18.5526 6.44714 19.7368 7.8945 19.7368H18.4208C19.8682 19.7368 21.0524 18.5526 21.0524 17.1053V5.26316C21.0524 3.81579 19.8682 2.63158 18.4208 2.63158H7.8945Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6584 9.86871H23.0269V13.8161H25.6584V9.86871Z",
    fill: "#999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6571 14.4741H23.0256C22.6571 14.4741 22.3677 14.1846 22.3677 13.8162V9.86883C22.3677 9.50041 22.6571 9.21094 23.0256 9.21094H25.6571C26.0256 9.21094 26.315 9.50041 26.315 9.86883V13.8162C26.315 14.1846 26.0256 14.4741 25.6571 14.4741ZM23.6835 13.1583H24.9993V10.5267H23.6835V13.1583Z",
    fill: "#999999"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.28929 9.86871H0.657715V13.8161H3.28929V9.86871Z",
    fill: "#999999"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.28947 14.4741H0.657894C0.289474 14.4741 0 14.1846 0 13.8162V9.86883C0 9.50041 0.289474 9.21094 0.657894 9.21094H3.28947C3.65789 9.21094 3.94737 9.50041 3.94737 9.86883V13.8162C3.94737 14.1846 3.65789 14.4741 3.28947 14.4741ZM1.31579 13.1583H2.63158V10.5267H1.31579V13.1583Z",
    fill: "#999999"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7361 19.7369H18.4203C17.6936 19.7369 17.1045 20.326 17.1045 21.0527V23.6842C17.1045 24.4109 17.6936 25 18.4203 25H19.7361C20.4628 25 21.0519 24.4109 21.0519 23.6842V21.0527C21.0519 20.326 20.4628 19.7369 19.7361 19.7369Z",
    fill: "#999999"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89476 19.7369H6.57897C5.85228 19.7369 5.26318 20.326 5.26318 21.0527V23.6842C5.26318 24.4109 5.85228 25 6.57897 25H7.89476C8.62145 25 9.21055 24.4109 9.21055 23.6842V21.0527C9.21055 20.326 8.62145 19.7369 7.89476 19.7369Z",
    fill: "#999999"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3682 14.4739H3.94714C3.22345 14.4739 2.63135 13.8818 2.63135 13.1581C2.63135 12.4345 3.22345 11.8423 3.94714 11.8423H22.3682C23.0919 11.8423 23.684 12.4345 23.684 13.1581C23.684 13.8818 23.0919 14.4739 22.3682 14.4739Z",
    fill: "#999999"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89384 18.4211H4.60436C3.88068 18.4211 3.28857 17.829 3.28857 17.1053C3.28857 16.3817 3.88068 15.7896 4.60436 15.7896H7.89384C8.61752 15.7896 9.20962 16.3817 9.20962 17.1053C9.20962 17.829 8.61752 18.4211 7.89384 18.4211Z",
    fill: "#999999"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7098 18.4211H18.4203C17.6966 18.4211 17.1045 17.829 17.1045 17.1053C17.1045 16.3817 17.6966 15.7896 18.4203 15.7896H21.7098C22.4334 15.7896 23.0255 16.3817 23.0255 17.1053C23.0255 17.829 22.4334 18.4211 21.7098 18.4211Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrouptransportation);
export default __webpack_public_path__ + "static/media/Grouptransportation.ebba3c12ff8fbd1149ed69eac7b37006.svg";
export { ForwardRef as ReactComponent };